import React from 'react'
import { Cells, Cell, CellBody, CellFooter, Toast } from 'react-weui'
import { connect } from 'react-redux'
import axios from 'axios'
import { TimeStream, renderLectureTimeStream, renderMoney } from '../../utils'
import ScheduleItem from './ScheduleItem'
import { WKBottomBtn, WKVisible } from '../../components/wk'
import { Pay, Page } from '../../components'


class SchedulePayPage extends React.Component {
    constructor (props) {
        super(props)
        this.state = {
            allInfo: {},
            schedule: {},
            stats_info: {},
            access_info: {},
            role: {},
            isPending: false,
        }
    }
    componentDidMount () {
        document.title = '安全支付'
        axios.get(`/api/schedule/${this.props.location.query.schedule_id}/info`)
            .then(res => {
                const data = res.data.data
                this.setState({
                    allInfo: data,
                    schedule: data.schedule,
                    stats_info: data.stats_info,
                    access_info: data.access_info,                    
                    role: data.role,
                })
            })
    }
    getTimeStr (item) {
        if (this.state.schedule.process === 'close') {
            return '已结束'
        }
        const { beg_timestamp, end_timestamp } = this.state.schedule
        if (!beg_timestamp && !end_timestamp) {
            return '-'
        }
        if (this.state.role.is_manager || this.state.schedule.process !== 'not_start') {
            return `${TimeStream(beg_timestamp, 'YMD')} 至 ${TimeStream(end_timestamp, 'YMD')}`
        } else {
            if (TimeStream(beg_timestamp, '-H') > 24) {
                return renderLectureTimeStream(beg_timestamp)
            } else {
                return TimeStream(beg_timestamp, '-H') + '小时后'
            }
        }
    }
    onClickPay () {
        this.props.dispatch({
            type: 'PAY_LIVEROOM',
            payload: {
                params: {
                    product: 'pay_schedule',
                    schedule_id: this.props.location.query.schedule_id,
                },
                success: () => {
                    location.replace(`/schedule/${this.props.location.query.schedule_id}/pay_success`)
                }
            }
        })
    }
    render() {
        const { schedule, stats_info, access_info } = this.state
        return (
            <Page>
            <div className="schedule-pay-page wk-page">
                <Pay />
                <ScheduleItem 
                    isHideLabel={true}
                    banner={schedule.banner}
                    title={schedule.name || '-'}
                    signinCount={schedule.current_day}
                    joinCount={stats_info.participate_count || 0}
                    time={this.getTimeStr()}
                    btnText=''
                    isBtnDisabled={false}
                    onClick={e => e}
                    isHideBtn={true}
                />
                <Cells>
                    <Cell>
                        <CellBody>
                            报名费
                        </CellBody>
                        <CellFooter>
                            <span className="red">￥{renderMoney(schedule.signup_fee || 0)}</span> 
                        </CellFooter>
                    </Cell>
                    <WKVisible create={stats_info.bonus_pools > 0} tag={null}>
                        <Cell>
                            <CellBody>
                                奖金池
                                {/* <WKVisible create={stats_info.bonus_carve_count > 0}> */}
                                    <div className="inner-intro">
                                        坚持打卡{schedule.bonus_condition_day}天，平分奖金池
                                    </div>
                                {/* </WKVisible> */}
                            </CellBody>
                            <CellFooter>
                                <span className="red">￥{renderMoney(stats_info.bonus_pools || 0)}</span> 
                            </CellFooter>
                        </Cell>
                    </WKVisible>
                </Cells>
                <div className="intro">温馨提示：付费打卡活动暂不支持退款</div>
                <WKVisible create={access_info.participate === false}>
                    <WKBottomBtn btnContent={{
                        text: '立即支付',
                        method: () => this.onClickPay()
                    }}/>
                </WKVisible>
                <Toast icon="loading" show={this.state.isPending}>支付中</Toast>
            </div>
            </Page>
        )
    }
}

export default connect()(SchedulePayPage)


// WEBPACK FOOTER //
// ./src/pages/schedule/SchedulePayPage.js